import type { CharacterDetail } from '@/mocks/characterDetail';

interface OriginProps {
  detail?: CharacterDetail;
}

const toneByIndex = [
  { wrap: 'border-primary-200/70', tag: 'text-primary-600', line: 'bg-primary-400' },
  { wrap: 'border-secondary-200/70', tag: 'text-secondary-700', line: 'bg-secondary-500' },
  { wrap: 'border-accent-200/70', tag: 'text-accent-700', line: 'bg-accent-500' },
];

export default function Origin({ detail }: OriginProps) {
  const blocks = detail?.originBlocks ?? [];

  return (
    <section className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="reveal mb-12 md:mb-16">
          <div className="mb-6 flex items-center gap-3">
            <span className="text-[11px] tracking-[0.34em] text-primary-600 uppercase">
              Origin
            </span>
            <span className="h-px w-8 bg-primary-300"></span>
            <span className="text-[11px] tracking-[0.28em] text-foreground-400 uppercase">
              一味 × 一境 × 一愿
            </span>
          </div>
          <h2 className="font-heading text-3xl tracking-[0.06em] text-foreground-950 md:text-4xl">
            它从哪里来
          </h2>
        </div>

        <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
          {blocks.map((block, index) => {
            const tone = toneByIndex[index] ?? toneByIndex[0];
            return (
              <article
                key={block.tag}
                className={`reveal rounded-lg border ${tone.wrap} bg-background-50 p-6 md:p-7`}
                style={{ transitionDelay: `${index * 120}ms` }}
              >
                <div className="flex items-center gap-3">
                  <span className={`h-px w-8 ${tone.line}`}></span>
                  <span className={`text-[11px] tracking-[0.24em] uppercase ${tone.tag}`}>
                    {block.en}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-2xl text-foreground-950">{block.title}</h3>
                <p className="mt-4 text-sm leading-relaxed text-foreground-600">{block.text}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}